// Import your store
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/styles.css'
import './assets/css/colors.css'
import store from './store/store.js'

// Dispatch the action to check for an existing logged-in user
store.dispatch('auth/initAuth').then(() => {
  createApp(App).use(store).use(router).mount('#app')
});
